import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as personnel from '../../../../personnel'
import * as engagement from '../engagement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagement.RESOURCE.payload.dimension.partialId,
      partialId: engagement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Meant to be used for finding similar employees to the one on this engagement based on shared attributes (e.g. skills, job title, etc.)',
    isOptional: true,
    name: 'Similar Employee',
    partialId: PartialId.Standard.create('similar_employee'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        personnel.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
